module.exports = __webpack_public_path__ + "static/media/tick-success.5d301df5.svg";